module.exports = __webpack_public_path__ + "static/img/ap9.3e34b8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap9.jpg
// module id = OxhH
// module chunks = 1